// extracted by mini-css-extract-plugin
module.exports = {"description":"_29yn9","single-example-description":"GP08d","singleExampleDescription":"GP08d"};